var SeoTextListItem = /** @class */ (function () {
    function SeoTextListItem(obj, id) {
        if (id) {
            this.id = id;
        }
        this.bg_description = obj.bg_description;
        this.en_description = obj.en_description;
    }
    Object.defineProperty(SeoTextListItem.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeoTextListItem.prototype, "BgName", {
        get: function () {
            return this.bg_description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeoTextListItem.prototype, "EnName", {
        get: function () {
            return this.en_description;
        },
        enumerable: false,
        configurable: true
    });
    return SeoTextListItem;
}());
export { SeoTextListItem };
export function createSeoText(obj, id) {
    return new SeoTextListItem(obj, id);
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/seoText/setText.ts
// module id = 462
// module chunks = 0